module.exports = __webpack_public_path__ + "img/nutrizon-diazon-energy-163x200-2.546e777d.png";